<div
  data-cy="create-warning-details"
  class="details position-absolute start-5 z-3 top-26 max-vh-70 overflow-auto"
  cdkDrag
  cdkDragBoundary="app-root"
  [class.d-none]="!hasFeatureDetails()"
>
  <app-details class="container-fluid p-0" (closed)="close()">
    <div class="p-2">
      <div class="row">
        <app-details-meta-category class="col gx-5" [category]="featureDetails().get('Hexagon')">
        </app-details-meta-category>
      </div>
      <div class="row mt-2 gy-2 justify-content-start">
        <div class="section-title col-12 text-start mt-2">Select type:</div>
        <div class="grid-items-container justify-content-start">
          <ng-container *ngIf="isLVLayerVisible">
            <ng-container *hasPermissionAny="Layers.LVWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_LowVisibility) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="isHRLayerVisible">
            <ng-container *hasPermissionAny="Layers.HRWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_HeavyRain) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="isHSLayerVisible">
            <ng-container *hasPermissionAny="Layers.HSWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_HeavySnow) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="isSWLayerVisible">
            <ng-container *hasPermissionAny="Layers.SWWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_StrongWind) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          </ng-container>
          <!-- Enable for tractionloss warnings once the backend supports it -->
          <!-- <ng-container *ngIf="isTLLayerVisible">
            <ng-container *hasPermissionAny="Layers.TLWarning.permissions">
              <app-button-icon *ngVar="getMetricFromMap(metrics.Warnings_TractionLoss) as metric"
                [description]="metric.displayName" [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key" [icon]="metric.icon" (clicked)="setMetric($event)"></app-button-icon>
            </ng-container>
          </ng-container> -->
        </div>
        <div class="duration-title col-12 text-start mt-2">Duration (min):</div>
        <div class="input-group col-12 mt-3">
          <input
            type="number"
            class="duration-input form-control border-0 shadow-none"
            min="4"
            max="3600"
            [defaultValue]="15"
            [(ngModel)]="duration"
            data-cy="duration-input"
          />
        </div>
        <div class="target-title col-12 text-start mt-3">Target:</div>
        <div class="target-selection d-flex flex-column gap-2 mt-2" isDemoEnabled>
          <div
            class="d-flex align-items-center gap-2"
            data-cy="target-checkboxes"
            *ngFor="let target of allowedTargets"
          >
            <input
              data-cy="target-checkbox"
              class="form-check-input mt-0"
              type="checkbox"
              [checked]="target.selected"
              (change)="this.validateScopes(target)"
            />
            <label class="target-label form-check-label mb-0 lh-1">{{ target.name }}</label>
          </div>
        </div>

        <!-- Extended Settings - Only visible with special permission -->
        <app-advanced-settings
          [(confidence)]="confidence"
          [(dfrs)]="dfrs"
          [(isExpanded)]="isAdvancedSettingsExpanded"
          [requiredPermissions]="[Permissions.RCS_Apps_All]"
        >
        </app-advanced-settings>
        <div class="col-12">
          <button
            data-cy="create-warning-button"
            class="btn btn-hover text-lightgray miw-100 mt-2 position-relative"
            (click)="createWarning()"
            [disabled]="disableButton || isLoading"
          >
            <span [class.invisible]="isLoading">Create warning</span>
            <div class="position-absolute translate-middle start-50 top-50">
              <div
                class="spinner-border text-lightgray spinner-border-sm"
                [class.d-none]="!isLoading"
                role="status"
              ></div>
            </div>
          </button>
        </div>
      </div>
    </div>

    <div
      cdkDragHandle
      class="rb-ic rb-ic-drag-handle text-gray fs-2xl z-3 position-absolute bottom-2 end-2 cursor-pointer hover-effect"
    ></div>
  </app-details>
</div>
